<mat-spinner diameter="30" *ngIf="loading || internalLoading"></mat-spinner>
<mat-form-field *ngIf="!loading && !internalLoading">
    <mat-chip-list #chipList aria-label="Role list">
        <mat-chip color="accent" *ngFor="let role of internalRoles" [selectable]="selectable"
                  [removable]="removable" (removed)="remove(role)">
            {{role.name}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let role of filteredRoles | async" [value]="role.name">
                {{role.name}}
            </mat-option>
        </mat-autocomplete>
        <input
            #inputElement
            placeholder="Manage roles"
            [formControl]="roleCtrl"
            [matChipInputFor]="chipList"
            [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
</mat-form-field>
